import { subscribe } from '../common/errors/sagas';
import { notificationError } from '../common/errors/notificationTypes';

const pre = 'INDEPENDENTAMOUNT/';

export const SET_GRID_SORTS = `${pre}SET_GRID_SORTS`;
export const SET_ACTIVE_VALUE = `${pre}SET_ACTIVE_VALUE`;
export const SET_ROW_CHECKED = `${pre}SET_ROW_CHECKED`;
export const SET_ALL_ROWS_CHECKED = `${pre}SET_ALL_ROWS_CHECKED`;

export const EXPORT_INDEPENDENT_AMOUNT_REPORTS = `${pre}EXPORT_INDEPENDENT_AMOUNT_REPORTS`;
export const EXPORT_INDEPENDENT_AMOUNT_REPORTS_SUCCESS = `${pre}EXPORT_INDEPENDENT_AMOUNT_REPORTS_SUCCESS`;
export const EXPORT_INDEPENDENT_AMOUNT_REPORTS_FAILED = `${pre}EXPORT_INDEPENDENT_AMOUNT_REPORTS_FAILED`;

export const EXPORT_IA_REPORT = `${pre}EXPORT_IA_REPORT`;
export const EXPORT_IA_REPORT_SUCCESS = `${pre}EXPORT_IA_REPORT_SUCCESS`;
export const EXPORT_IA_REPORT_FAILED = `${pre}EXPORT_IA_REPORT_FAILED`;

export const SET_DEFAULT_FILTERS = `${pre}SET_DEFAULT_FILTERS`;
export const SET_RUNDATE = `${pre}SET_RUNDATE`;

export const INDEPENDENT_AMOUNT_LOADED = `${pre}INDEPENDENT_AMOUNT_LOADED`;
export const SET_INDEPENDENT_AMOUNT_LOADING = `${pre}SET_INDEPENDENT_AMOUNT_LOADING`;
export const SET_INDEPENDENT_AMOUNT_INITIALISED = `${pre}SET_INDEPENDENT_AMOUNT_INITIALISED`;
export const GET_INDEPENDENT_AMOUNT = `${pre}GET_INDEPENDENT_AMOUNT`;
export const GET_INDEPENDENT_AMOUNT_SUCCESS = `${pre}GET_INDEPENDENT_AMOUNT_SUCCESS`;
export const GET_INDEPENDENT_AMOUNT_FAILED = `${pre}GET_INDEPENDENT_AMOUNT_FAILED`;

export const GET_IA_REPORTS_STATUS_SUCCESS = `${pre}GET_IA_REPORTS_STATUS_SUCCESS`;
export const GET_IA_REPORTS_STATUS_FAILED = `${pre}GET_IA_REPORTS_STATUS_FAILED`;
export const REFRESH_INDEPENDENT_AMOUNT = `${pre}REFRESH_INDEPENDENT_AMOUNT`;
subscribe(GET_INDEPENDENT_AMOUNT_FAILED, 'There was an error retrieving the ia results from the database', notificationError);

export const setGridSorts = (gridId, sorting) => ({
    type: SET_GRID_SORTS,
    gridId,
    sorting
});
export const independentAmountConnected = search => ({
    type: INDEPENDENT_AMOUNT_LOADED,
    search
});

export const setIndependentAmountLoading = loading => ({
    type: SET_INDEPENDENT_AMOUNT_LOADING,
    loading
});

export const setIndependentAmountInitialised = initialised => ({
    type: SET_INDEPENDENT_AMOUNT_INITIALISED,
    initialised
});

export const getIndependentAmount = () => ({
    type: GET_INDEPENDENT_AMOUNT
});

export const getIndependentAmountSuccess = result => ({
    type: GET_INDEPENDENT_AMOUNT_SUCCESS,
    result
});

export const getIndependentAmountFailed = error => ({
    type: GET_INDEPENDENT_AMOUNT_FAILED,
    error
});

export const getReportsSuccess = (result1,result2) => ({
    type:GET_IA_REPORTS_STATUS_SUCCESS,
    result1,
    result2
})

export const getReportsFailed = error => ({
    type: GET_IA_REPORTS_STATUS_FAILED,
    error
});

export const refreshIndependentAmount = () => ({
    type: REFRESH_INDEPENDENT_AMOUNT    
});

export const setDefaultFilters = filters => ({
    type: SET_DEFAULT_FILTERS,
    filters
});

export const setRunDate = date => ({
    type: SET_RUNDATE,
    date
});
export const exportCalcReports = (ids) => ({
    type: EXPORT_INDEPENDENT_AMOUNT_REPORTS,
    ids
});
export const exportCalcReportsFailed = (error) => ({
    type: EXPORT_INDEPENDENT_AMOUNT_REPORTS_FAILED,
    error
});

export const exportCalcReportsSuccess = (downloadFile) => ({
    type: EXPORT_INDEPENDENT_AMOUNT_REPORTS_SUCCESS,
    downloadFile
});

export const exportReport = (fileInfo) => ({
    type: EXPORT_IA_REPORT,
    fileInfo
});

export const exportReportFailed = (error) => ({
    type: EXPORT_IA_REPORT_FAILED,
    error
});

export const exportReportSuccess = (downloadFile) => ({
    type: EXPORT_IA_REPORT_SUCCESS,
    downloadFile
});
export const setActiveValue = (key, value, rowId) => ({
    type: SET_ACTIVE_VALUE,
    key,
    value,
    rowId
});

export const setRowChecked = (id, checked) => ({
    type: SET_ROW_CHECKED,
    id,
    checked
});

export const setAllRowsChecked = checked => ({
    type: SET_ALL_ROWS_CHECKED,
    checked
});


